import { DELETION_OF_PHOTOBLOG_COMMENT, DELETION_OF_PHOTOBLOG_POST } from 'mk/autogenerated/translations/Deletion.constants.a6d64fa915e34fb4fdd569078c16c551'
import { DeletionTargetType } from './Deletion.schemas';

export const TITLES = {
    [DeletionTargetType.PhotoblogComment]: DELETION_OF_PHOTOBLOG_COMMENT,
    [DeletionTargetType.PhotoblogPost]: DELETION_OF_PHOTOBLOG_POST,
};
